import { patchTask } from '@fno/service/api/tasks.js'
import { preFormMutator, preSaveMutator, getKeypath, preChangeMutator, nextHandler, previousHandler } from '@fno/route/tab/task/helpers.js'
import { patchSchool } from '@fno/service/api/schools.js'
import genericChange from '@fno/lib/form/generic-change.js'
import genericReset from '@fno/lib/form/generic-reset.js'
import genericSave from '@fno/lib/form/generic-save.js'
import tabToolSchema from 'fanx-schema/resource/taskTabTool'
import appColorsSchema from 'fanx-schema/resource/appColors'
import schoolSchema from 'fanx-schema/resource/school'

import template from './AppColors.svelte'
import transformApiResponseToFormObject from '@fno/lib/transform-api-response-to-form-object.js'
import setContextOriginal from '@fno/lib/form/set-context-original.js'

import { getSchool } from '@fno/service/api/schools'
import { getTabTool } from '@fno/service/api/tasks'
import { getAppColors, patchAppColors } from '@fno/service/api/colors.js'

const page = {
    school: {
        type: Object,
        schema: schoolSchema,
        patch: (school) => patchSchool({ school })
    },
    clientOnboarding: {
        type: Object,
        schema: tabToolSchema,
        patch: (task) => patchTask({ task })
    },
    appColors: {
        type: Object,
        schema: appColorsSchema,
        patch: (colors) => patchAppColors({ colors })
    }
}

export default (parent, stateRouter) => {
    const name = `${parent}.appColors`

    stateRouter.addState({
        name,
        route: '/appColors',
        template,
        data: {
            title: 'Design Your App | T.A.B.'
        },
        resolve: async (ignore, { schoolId }) => {
            const [ appColors, { school }, task ] = await Promise.all([
                getAppColors({ schoolId }),
                getSchool({ schoolId }),
                getTabTool({ schoolId })
            ])

            if (!appColors.attributes.backgroundColor && !appColors.attributes.launchIcon) appColors.attributes.backgroundColor = '000000'
            if (!appColors.attributes.dark) appColors.attributes.dark = false
            if (!appColors.attributes.primary) appColors.attributes.primary = '440BD4'
            if (!appColors.attributes.secondary) appColors.attributes.secondary = 'FF2079'

            const context = {
                context: {
                    form: {
                        school: transformApiResponseToFormObject({
                            schema: schoolSchema,
                            data: school
                        }),
                        clientOnboarding: transformApiResponseToFormObject({
                            schema: tabToolSchema,
                            data: task
                        }),
                        appColors: transformApiResponseToFormObject({
                            schema: appColorsSchema,
                            data: appColors
                        })
                    },
                    view: {
                        appColorsSchema
                    }
                }
            }

            return setContextOriginal(context, preFormMutator)
        },
        activate: ({ domApi: component, parameters: { schoolId } }) => {
            const save = genericSave({ component, page, preSaveMutator, preFormMutator })
            component.$on('nextStepClicked', nextHandler({
                stateRouter,
                component,
                save,
                schoolId,
                stepId: 'APP_COLORS',
                nextId: 'venues'
            }))
            component.$on('previousStepClicked', previousHandler(stateRouter, 'appIcons', schoolId))
            component.$on('save', save)
            component.$on('change', genericChange({ component, page, getKeypath, preChangeMutator }))
            component.$on('reset', genericReset({ component }))
        }
    })
}
